import { getSearchResultQuery, postSearchResultFeedbackQuery } from './ai-search.query';
import { AISearchResult } from './ai-search.types';
import { ApiResponse, query as graphQLQuery } from './api';

interface AISearchInterface {
  getSearchResult(query: string, sessionId: string): ApiResponse<AISearchResult>;
  postSearchResultFeedback(
    search_id: string,
    session_id: string,
    data: {
      is_correct?: boolean;
      comment?: string;
    }
  ): ApiResponse<{ success: boolean }>;
}

export const AISearchApi: AISearchInterface = {
  async getSearchResult(query: string, sessionId: string) {
    return graphQLQuery({
      query: getSearchResultQuery,
      variables: { query, session_id: sessionId },
      name: 'getSearchResult',
    }).then(({ getSearchResult }) => ({ data: getSearchResult }));
  },

  async postSearchResultFeedback(
    search_id: string,
    session_id: string,
    data: { is_correct?: boolean; comment?: string }
  ) {
    return graphQLQuery({
      query: postSearchResultFeedbackQuery,
      variables: { search_id, is_correct: data.is_correct, comment: data.comment, session_id },
      name: 'postSearchResultFeedback',
    }).then(({ postSearchResultFeedback }) => ({ data: postSearchResultFeedback }));
  },
};
